import julian from 'julian';
import moment from 'moment';

export const julianToday = () =>
  parseInt( julian( new Date() ), 10 );

export const julianToMoment = date =>
  date > 0 ? moment( julian.toDate( date ) ) : undefined

export const toJulian = date => {
  if ( !date ) return date;
  const jsDate = typeof date.toDate === 'function' ? date.toDate() : date;
  return parseInt( julian( jsDate ), 10 );
};


// WEBPACK FOOTER //
// ./src/functions/dates.js